import { render } from "./ChartBarComp.vue?vue&type=template&id=3b383b24"
import script from "./ChartBarComp.vue?vue&type=script&lang=js"
export * from "./ChartBarComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__